import { useQuery, useSuspenseQuery } from "@tanstack/react-query";
import { METRIC_STALE_TIME } from "../constants";
import { api } from "../utils/apiClient";
import type { Airline } from "../types";

export type UserAirlinesResponse = {
  airlines: Airline[];
};

const fetchUserAirlines = async (): Promise<UserAirlinesResponse> => {
  const res = await api.get("/api/v1/user-airlines");
  if (!res.ok) throw new Error(`Failed to load user airlines: ${res.status}`);
  return res.json();
};

export const userAirlinesQueryOptions = {
  queryKey: ["/api/v1/user-airlines"],
  queryFn: () => fetchUserAirlines(),
  select: (data: UserAirlinesResponse) => data.airlines,
  staleTime: METRIC_STALE_TIME,
};

export const useUserAirlinesQuery = () => {
  return useQuery({
    queryKey: ["/api/v1/user-airlines"],
    queryFn: () => fetchUserAirlines(),
    select: (data: UserAirlinesResponse) => data.airlines,
    staleTime: METRIC_STALE_TIME,
  });
};

export const useUserAirlinesSuspenseQuery = () => {
  return useSuspenseQuery({
    queryKey: ["/api/v1/user-airlines"],
    queryFn: () => fetchUserAirlines(),
    select: (data: UserAirlinesResponse) => data.airlines,
    staleTime: METRIC_STALE_TIME,
  });
};
